import { render, staticRenderFns } from "./xny.vue?vue&type=template&id=b4132fa0&scoped=true&"
import script from "./xny.vue?vue&type=script&lang=js&"
export * from "./xny.vue?vue&type=script&lang=js&"
import style0 from "./xny.vue?vue&type=style&index=0&id=b4132fa0&lang=less&scoped=true&"
import style1 from "./xny.vue?vue&type=style&index=1&id=b4132fa0&lang=less&scoped=true&"
import style2 from "./xny.vue?vue&type=style&index=2&id=b4132fa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4132fa0",
  null
  
)

export default component.exports